import React from 'react';
import LoginPage from './pages/login/login';
import LoginPage2 from './pages/login/login2';
import LoginApplyCodePage from './pages/login/apply-sms-code';
import LoginSelectOtpPage from './pages/login/select-otp-number';

import MessagesPage from './pages/Messages/messages';
import PackagesPage from './pages/packages/packages';
import ChooseTitle from './pages/Messages/message-steps/choose-title';
import TextMessage from './pages/Messages/message-steps/text-message';
import Receivers from './pages/Messages/message-steps/receivers';
import DeliveryTime from './pages/Messages/message-steps/delivery-time';
import FastLogin from 'pages/login/fast-login';
import ForgotPasswordPage from './pages/forgot-password/forgot-password';
import ForgotPasswordApplyCodePage from './pages/forgot-password/apply-sms-code';
import ForgotPasswordNewPasswordPage from './pages/forgot-password/new-password';
import OrderSuccessful from './pages/Order/order-successful';
import ReportsPage from './pages/reports/reports';
import SignupPage from './pages/signup/signup';
import SignupApplyCodePage from './pages/signup/apply-sms-code';
import SignupNewPasswordPage from './pages/signup/new-password';

import Profile from './pages/Profile/Profile/profile';
import Permission from './pages/Profile/Permission/permission';
import History from './pages/Profile/History/history';
import Title from './pages/Profile/Title/title';
import CreateTitleStep1 from './pages/Profile/Title/createTitleStep1';
import CreateTitleStep2 from './pages/Profile/Title/createTitleStep2';

import SupportCreditPurchase from './pages/Support/credit-purchase';
import SupportReports from './pages/Support/reports';
import SupportAccounts from './pages/Support/accounts';
import SupportShippingTransactions from './pages/Support/shipping-transactions';

import Guide from './pages/Guide/guide';
import BlackList from './pages/BlackList/black-list';

import MainPage from './pages/SinglePage/main-page';
import PackagesAndPayment from './pages/SinglePage/packages-and-payment';
import Blog from './pages/SinglePage/blog';
import Marketing from './pages/SinglePage/marketing';

import PageList from './pages/PageList/PageList';
import MsisdnList from 'pages/Profile/MsisdnList/msisdinlist';
import IpList from 'pages/Profile/IpList/iplist';
import { MessageCreate, SignupMobileSignature } from 'pages';
import { HOW_IT_WORKS_PAGE, MMS_PAGE } from 'constants/page.const';
import MMSPage from 'pages/SinglePage/mms';
import SMSPage from 'pages/SinglePage/sms';
import HowItWorksPage from 'pages/SinglePage/how-it-works';
import IYSPage from 'pages/SinglePage/iys';

import NotificationBoxes from './pages/NotificationBoxes/notification-boxes';
import OrderError from 'pages/Order/order-error';
import MMSWhatPage from 'pages/SinglePage/mms-nedir';
import KobiBlogPage from 'pages/SinglePage/kobiler-icin-toplu-sms';
import BayramPage from 'pages/SinglePage/bayram';
import YeniYil from 'pages/SinglePage/yeni-yil';
import SmsNedirPage from 'pages/SinglePage/sms-nedir';
import MobileSignature from 'pages/login/mobile-signature';

//const path = '/mesajussu/build';
const path = '';

const routes = [
  {
    path: `${path}/Packages`,
    component: PackagesPage,
  },
  {
    path: `${path}/Login`,
    component: LoginPage,
  },
  {
    path: `${path}/Login2/:msisdn`,
    component: LoginPage2,
  },
  {
    path: `${path}/Login/:gsmNumber/otp`,
    component: LoginSelectOtpPage,
  },
  {
    path: `${path}/Login/:mainNumber/:gsmNumber/otp-confirmation`,
    component: LoginApplyCodePage,
  },
  {
    path: `${path}/Login/:gsmNumber`,
    component: MobileSignature,
  },
  {
    path: `${path}/FastLogin`,
    component: FastLogin,
  },
  {
    path: `${path}/messages`,
    component: MessagesPage,
  },
  {
    path: `${path}/NewMessage`,
    component: MessageCreate,
  },
  {
    path: `${path}/ChooseTitle`,
    component: ChooseTitle,
  },
  {
    path: `${path}/TextMessage`,
    component: TextMessage,
  },
  {
    path: `${path}/Receivers`,
    component: Receivers,
  },
  {
    path: `${path}/DeliveryTime`,
    component: DeliveryTime,
  },
  {
    path: `${path}/ForgotPasswordPage`,
    component: ForgotPasswordPage,
  },
  {
    path: `${path}/ForgotPasswordApplyCodePage/:gsmNumber`,
    component: ForgotPasswordApplyCodePage,
  },
  {
    path: `${path}/ForgotPasswordNewPasswordPage`,
    component: ForgotPasswordNewPasswordPage,
  },
  {
    path: `${path}/ForgotPasswordNewPasswordPage/:gsmNumber`,
    component: ForgotPasswordNewPasswordPage,
  },
  {
    path: `${path}/OrderSuccessful`,
    component: OrderSuccessful,
  },
  {
    path: `${path}/OrderError`,
    component: OrderError,
  },
  {
    path: `${path}/ReportsPage`,
    component: ReportsPage,
  },
  {
    path: `${path}/Signup`,
    component: SignupPage,
  },
  {
    path: `${path}/Signup/:gsmNumber`,
    component: SignupMobileSignature,
  },
  {
    path: `${path}/Signup/:gsmNumber/newPassword`,
    component: SignupNewPasswordPage,
  },
  {
    path: `${path}/Profile`,
    component: Profile,
  },
  {
    path: `${path}/Permission`,
    component: Permission,
  },
  {
    path: `${path}/MsisdnList`,
    component: MsisdnList,
  },
  {
    path: `${path}/IpList`,
    component: IpList,
  },
  {
    path: `${path}/History`,
    component: History,
  },
  {
    path: `${path}/Title`,
    component: Title,
  },
  {
    path: `${path}/Title/:status`,
    component: Title,
  },
  {
    path: `${path}/Identity`,
    component: CreateTitleStep1,
  },
  {
    path: `${path}/Company`,
    component: CreateTitleStep2,
  },
  {
    path: `${path}/CreditPurchaseHelp`,
    component: SupportCreditPurchase,
  },
  {
    path: `${path}/MessagesHelp`,
    component: SupportShippingTransactions,
  },
  {
    path: `${path}/ReportsHelp`,
    component: SupportReports,
  },
  {
    path: `${path}/AccountsHelp`,
    component: SupportAccounts,
  },
  {
    path: `${path}/Guide`,
    component: Guide,
  },
  {
    path: `${path}/BlackList`,
    component: BlackList,
  },
  {
    path: `${path}/PageList`,
    component: PageList,
  },
  {
    path: `${path}/nasil-calisir`,
    component: HowItWorksPage,
  },
  {
    path: `${path}/iys-nedir`,
    component: IYSPage,
  },
  {
    path: `${path}/bayram-mesajlari`,
    component: BayramPage,
  },
  {
    path: `${path}/yeni-yil-mesajlari`,
    component: YeniYil,
  },
  {
    path: `${path}/sms-nedir-sms-ve-toplu-sms-hakkinda-bilinmesi-gerekenler`,
    component: SmsNedirPage,
  },
  {
    path: `${path}/paketler`,
    component: PackagesAndPayment,
  },
  {
    path: `${path}/blog`,
    component: Blog,
  },
  {
    path: `${path}/marketing`,
    component: Marketing,
  },
  {
    path: `${path}/toplu-sms`,
    component: SMSPage,
  },
  {
    path: `${path}/kobiler-icin-toplu-sms`,
    component: KobiBlogPage,
  },
  {
    path: `${path}/toplu-mms-nedir`,
    component: MMSPage,
  },
  {
    path: `${path}/toplu-mms-zim`,
    component: MMSPage,
  },
  {
    path: `${path}/`,
    component: MainPage,
  },
  {
    path: `${path}/notif`,
    component: NotificationBoxes,
  },
];

export default routes;
